module.exports = __webpack_public_path__ + "static/third-099a8a6b0dc557c34b896900f471166b.svg";